import { render, staticRenderFns } from "./AssetsList.vue?vue&type=template&id=072a7c34"
import script from "./AssetsList.vue?vue&type=script&lang=js"
export * from "./AssetsList.vue?vue&type=script&lang=js"
import style0 from "./AssetsList.vue?vue&type=style&index=0&id=072a7c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports